import styled from 'styled-components'

import { FONT_SIZE, COLOR } from '../../../../../themes'

const Style = styled.div`
  font-family: LibreBaskervilleBold;
  font-size: ${FONT_SIZE.LG2};
  color: ${COLOR.BLACK};
  padding: 32px 32px 0px 24px;
`

export default Style
